import React, { useState } from 'react';

import { Checkbox, MenuItem } from '@material-ui/core';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { StyledFilterDisplay, ScrollableContainer, LastMenuItem } from '../styles';

const FixedFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon, filterValues = [] }) => {
  const [selected, setSelected] = useState({});

  const makeCurrentStateEqualToSelectedState = () => {
    const selected = {};
    selectedFilters.forEach((id) => (selected[id] = true));
    setSelected(selected);
  };

  const handleSelect = (value) => {
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  };

  const handleApplyClick = () => {
    updateFilters(
      Object.keys(selected).filter((id) => selected[id]),
      filterName
    );
    document.body.click();
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <CustomMenu
      icon={
        <StyledFilterDisplay
          width="20%"
          icon={icon}
          name={filterName}
          selectedCount={selectedFilters.length}
          noLeftBorder={noLeftBorder}
          active={selectedFilters.length > 0}
          removeFilters={removeFilters}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
    >
      <StyledDropdownList>
        <ScrollableContainer>
          {filterValues.map((filterValue, index) => (
            <MenuItem onClick={() => handleSelect(filterValue)} value={filterValue}>
              <Checkbox checked={Boolean(selected[filterValue])} color="primary" />
              <StyledTypography display="inline" variant="body2">
                {filterValue.replace(/'/g, '')}
              </StyledTypography>
            </MenuItem>
          ))}
        </ScrollableContainer>
        <LastMenuItem onClick={handleApplyClick}>
          <StyledTypography color="primary" variant="body2">
            Apply
          </StyledTypography>
        </LastMenuItem>
      </StyledDropdownList>
    </CustomMenu>
  );
};

const StyledDropdownList = styled(DropdownList)`
  li {
    padding-left: 5px;
    span.MuiButtonBase-root {
      padding: 4px 10px;
    }
  }
`;

export default FixedFilter;
